import { t } from 'i18next';

export const getButtonText = (
  isSubmitting: boolean,
  isUploading: boolean,
  isValidating: boolean,
) => {
  let buttonText = t('button.import');
  if (isSubmitting) {
    buttonText = t('button.importing');
  }
  if (isUploading) {
    buttonText = t('button.uploading');
  }
  if (isValidating) {
    buttonText = t('button.validating');
  }
  return buttonText;
};
